/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMutation, useSuspenseQuery } from '@tanstack/react-query';
import { get, post } from '@api/httpClient'; // Adjust if your httpClient lives elsewhere
import { AxiosResponse } from 'axios';
import { APIError } from '../types'; // Adjust if APIError lives somewhere else

// --- Payload Interface ---
interface GenerateReportPayload {
  outputId: string;
  reportType: string; // e.g., "TEST", "CANCER"
}

export interface GenerateReportResponse {
  id: string;
  message: string;
  report_type: string;
  report_id: string;
}

// --- Mutation Hook: Generate Report ---
export const useGenerateReport = () =>
  useMutation<
    AxiosResponse<GenerateReportResponse>,
    APIError,
    GenerateReportPayload
  >({
    mutationFn: async ({ outputId, reportType }) =>
      post(`/report/submit/${outputId}/${reportType}/`),
  });

// --- Utility: Download Latest Report ---
export const downloadLatestReport = async (outputId: string) => {
  const response = await get(`/reports/${outputId}/download_latest/`, {
    responseType: 'blob',
  });
  return response;
};

// --- Utility: Download Report by ID ---
export const downloadReportById = async (reportId: string) => {
  const response = await get(`/reports/${reportId}/download/`, {
    responseType: 'blob',
  });
  return response;
};

// --- Utility: Get Report ---
export const useGetReports = (params: Record<string, any> = {}) =>
  useSuspenseQuery({
    queryKey: ['reports', params],
    queryFn: async () => {
      const response = await get('/reports/', { params });
      return response.data;
    },
  });

// --- Utility: Get Report by ID ---
export const useGetReportById = (reportId: string) =>
  useSuspenseQuery({
    queryKey: ['report', reportId],
    queryFn: async () => {
      const response = await get(`/reports/${reportId}/`);
      return response.data;
    },
  });
